import React from "react";
import Searchbar from "../searchbar/searchbar";
import styled from "./style.module.css";
const Layout = ({ children }) => {
  return (
    <div className={styled.layoutMainContainer}>
      <Searchbar />
      <div className="p-4">{children}</div>
    </div>
  );
};

export default Layout;
